import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SuccessIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 17 16"
			fill="none"
			className={props.className}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M8.5 16C12.88 16 16.5 12.37 16.5 8C16.5 3.62 12.87 0 8.49 0C4.12 0 0.5 3.62 0.5 8C0.5 12.37 4.13 16 8.5 16ZM8.5 14.67C4.8 14.67 1.84 11.7 1.84 8C1.84 4.3 4.79 1.33 8.49 1.33C12.19 1.33 15.16 4.3 15.17 8C15.17 11.7 12.2 14.67 8.5 14.67ZM7.64 11.73C7.9 11.73 8.12 11.6 8.27 11.36L11.86 5.72C11.94 5.56 12.05 5.39 12.05 5.22C12.05 4.86 11.73 4.64 11.4 4.64C11.21 4.64 11.01 4.76 10.86 4.99L7.61 10.21L6.06 8.21C5.87 7.96 5.7 7.9 5.48 7.9C5.14 7.9 4.88 8.17 4.88 8.52C4.88 8.69 4.95 8.85 5.06 9L6.97 11.36C7.17 11.62 7.38 11.73 7.64 11.73Z"></path>
		</svg>
	)
}

export default SuccessIcon
